import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAsD7V0btsxhKtgVECS0FREZFeYgzry1Zg",
  authDomain: "clubmate-8665c.firebaseapp.com",
  projectId: "clubmate-8665c",
  storageBucket: "clubmate-8665c.firebasestorage.app",
  messagingSenderId: "279552251342",
  appId: "1:279552251342:web:6387168bef642a1c2f479f",
  measurementId: "G-4DH83MC5X8"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const db = firebase.firestore();